import { apiPatch } from '../client';

export async function updatePurchaseOrderCategory(id: number, category: string): Promise<void> {
  return apiPatch<void>(`transactions/purchase-orders/${id}/category`, { category });
}
